export const translateNotificationStatuses = (status?: string) => {
	switch (status) {
		case 'error':
			return 'Ошибка';
		case 'success':
			return 'Успешно';
		default:
			return '';
	}
};
